import React from 'react';

function About() {

    return(
        <section className="container">
            <h2 className="top-title">Jamie Jackson</h2>
            <hr></hr>
            <div>
                <img className="mb-5" id="avatar" src="https://avatars.githubusercontent.com/u/89232885?v=4" alt="Jamie Jackson" />

                <p>
                Front-end web developer leveraging government and commercial backgrounds to build a more relevant and user-friendly experience on the web. 
                Recently earned a certificate in coding to include full-stack development from Rice University with newly developed skills in JavaScript, CSS, HTML, jQuery, Bootstrap, Node.js, MySQL, MongoDB, Express.js, and React.js.
                My goal is to develop web pages, with a focus on functionality and aesthetic design. With each project, my aim is to create an application that provides the user with an interactive, intuitive, and customized experience from design to deployment. 
                I applied aspects of full stack web development in a recent project where I worked on a team of four to develop a social media app, bringing new and relevant updates within their network of connections. I led the project app which develops routes to the front-end.  
                I’m excited to leverage my skills as part of a fast-paced, quality-driven team to build better experiences on the web.
                </p>
            
            </div>
        </section>
    )
}

export default About;

